import { useDarkModeAvailable } from 'app/hooks/useDarkModeAvailable'
import { useMediaQuery } from 'app/hooks/useMediaQuery'
import { useThemeReady } from 'app/hooks/useThemeReady'
import { useUserSettingStore } from 'app/stores/StoreContext'
import { bg } from 'lib/background'
import { APPEARANCE_THEME_SETTING, parseThemePreference, resolveTheme } from 'lib/theme'

/**
 * The one-click Light/Dark switch of the sidebar (unlike the Profile Appearance section,
 * it has no System option). Callers must be wrapped in `observer()`.
 */
export function useThemeToggle(): { available: boolean; ready: boolean; isDark: boolean; toggle: () => void } {
  const available = useDarkModeAvailable()
  const ready = useThemeReady()
  const store = useUserSettingStore()
  const systemPrefersDark = useMediaQuery(`(prefers-color-scheme: dark)`)

  const isDark =
    resolveTheme({
      toggleEnabled: true,
      preference: parseThemePreference(store.settings[APPEARANCE_THEME_SETTING]),
      systemPrefersDark,
    }) === `dark`

  return {
    available,
    ready,
    isDark,
    toggle: () => bg(async () => store.save(APPEARANCE_THEME_SETTING, JSON.stringify(isDark ? `light` : `dark`))),
  }
}
